import React from 'react';
import Footer from '../layout/Footer/Footer';

const footers = [{ path: '*', element: <Footer /> }];

export default footers;
